import React, { Suspense } from 'react';
import { ErrorBoundary } from '@/shared/components/common/ErrorBoundary';
import Loader from '@/shared/components/ui/loader';

interface Options {
  fallback?: React.ReactNode;
  errorFallback?: React.ReactNode;
  onError?: (error: Error, errorInfo: React.ErrorInfo) => void;
}

/** Wraps a lazy route component with loading and render-error fallbacks. */
export default function loadable<T extends React.ComponentType<any>>(
  importFunc: () => Promise<{ default: T }>,
  { fallback = <Loader />, errorFallback, onError }: Options = {}
) {
  const LazyComponent = React.lazy(importFunc);
  return (props: React.ComponentProps<T>) => (
    <ErrorBoundary fallback={errorFallback} onError={onError}>
      <Suspense fallback={fallback}>
        <LazyComponent {...props} />
      </Suspense>
    </ErrorBoundary>
  );
}
